import axios from 'axios';
import _ from 'lodash';
import { handlePostWithResult } from '../../../../utils/AxiosUtil';
import * as enums from '../../../../utils/EnumMapping';
import { trimSpaces } from '../../../../utils/Util';

export const fields = [
    'billNumber', 'billDate', 'fullFillmentDate', 'paymentDeadline', 'amount', 'vat', 'comment'
]
export const promiseCustomerOptions = async () => {
    console.log("promiseCustomerOptions");
    const response = await axios.get('/api/incomingbill/customers')
    const renamedCustomers = [];
    response.data.map((customer) =>
        renamedCustomers.push({
            label: customer.name,
            value: customer.privateId,
        }));
    return renamedCustomers;
};

export const promiseLinkBillOptions = async (this2) => {
    if (this2.state.selectedCustomer && this2.state.selectedCustomer !== null && !_.isEmpty(this2.state.selectedCustomer) && "BILL" !== this2.state.selectedType.value) {
        console.log("promiseLinkBillOptions");
        const requestObject = { "customerId": this2.state.selectedCustomer.value, "type": this2.state.selectedType.value };
        const response = await axios.post('/api/incomingbill/linkbill', requestObject);
        console.log(response);
        const renamedLinkedBills = [];
        response.data.map((bill) =>
            renamedLinkedBills.push({
                label: "Sorszám: " + bill.publicId,
                value: bill.publicId,
                proforma: getLabelForLinkedBill(bill.bills, "PROFORMA"),
                prepayment: getLabelForLinkedBill(bill.bills, "PREPAYMENT"),
            }));
        return renamedLinkedBills;
    }
    return [];
};

const getLabelForLinkedBill = (bills, type) => {
    let bill = bills.find((bill) => type === bill.type);
    if (bill) {
        return bill.billNumber;
    } else {
        return null;
    }
}

export const handleCustomerSelected = (e, v, this2) => {
    var b = false;
    if (v === null) {
        b = true;
    }
    if (v && v.inputValue) {
        //new customer
        const path = '/api/incomingbill/customer';
        const requestObject = { "name": v.inputValue };
        handlePostWithResult(path, requestObject, (res) => handleSuccessNewCustomer(v, res.privateId, this2), this2);
    } else {
        this2.setState({ selectedCustomer: v, customerRelatedDropDown: b })
    }
}

const handleSuccessNewCustomer = (v, id, this2) => {
    let newCustomer = {
        label: v.inputValue,
        value: id,
    }
    this2.setState({ selectedCustomer: newCustomer, customerRelatedDropDown: false })
    v.label = v.inputValue;
}

//Car Insurance
export const promiseCarOptions = async () => {
    const response = await axios.get('/api/cars')
    return response.data.map(resp => ({
        label: resp.licenseNumber,
        value: resp.privateId
    }));
};

export const handleCarSelected = (e, v, this2) => {
    console.log(v);
    this2.setState({ selectedCar: v })
}

//category
export const promiseCategoryOptions = async () => {
    const response = await axios.get('/api/incomingbill/categories')
    const renamedCategories = [];
    response.data.map((customer) =>
        renamedCategories.push({
            label: customer.name,
            value: customer.privateId,
        }));
    return renamedCategories;
};

export const handleCategorySelected = (e, v, this2) => {
    if (v && v.inputValue) {
        //new category
        const path = '/api/incomingbill/category';
        const requestObject = { "name": v.inputValue };
        handlePostWithResult(path, requestObject, (res) => handleSuccessNewCategory(v, res.privateId, v.inputValue, this2), this2);

    } else {
        this2.setState({ selectedCategory: v })
    }
}

const handleSuccessNewCategory = (v, id, name, this2) => {
    let newCategory = {
        label: name,
        value: id,
    }
    this2.setState({ selectedCategory: newCategory })
    v.label = v.inputlabel;
}



export const handleLinkBillSelected = (e, v, this2) => {
    this2.setState({ selectedLinkBill: v })
}

export const handleBillTypeChange = (event, this2) => {
    handleBillTypeChangeGeneral(event.target.value, this2);
}

export const handleBillTypeChangeGeneral = (option, this2) => {
    let type = option.value;
    let b = "PREPAYMENT" === type || "FINAL_BILL" === type;
    this2.setState({ selectedType: option, hideLinkBillComponent: !b, selectedLinkBill: {} })
}

export const handlePaymentMethodChange = (event, this2) => {
    let type = event.target.value.value;
    let b = "CASH" === type || "CREDIT_CARD" === type;
    this2.setState({ selectedPaymentMethod: event.target.value, disableBillTypeComponent: b, selectedType: enums.billTypes[0] })
    handleBillTypeChangeGeneral(enums.billTypes[0], this2);
}

export const handleBillDateChange = (value, this2) => {
    this2.setState({ billDate: value });
    if (this2.state.selectedPaymentMethod.value === "CASH") {
        this2.setState({ fulfillmentDate: value, paymentDeadline: value, equalizationDate: value });
    }
    removeErrorMessage("billDate", this2);
}

export const handleFulfillmentDateChange = (value, this2) => {
    this2.setState({ fulfillmentDate: value });
    if (this2.state.selectedPaymentMethod.value === "CASH") {
        this2.setState({ billDate: value, paymentDeadline: value, equalizationDate: value });
    }
    removeErrorMessage("fullFillmentDate", this2);
}

export const handlePaymentDeadlineChange = (value, this2) => {
    this2.setState({ paymentDeadline: value });
    if (this2.state.selectedPaymentMethod.value === "CASH") {
        this2.setState({ billDate: value, fulfillmentDate: value, equalizationDate: value });
    }
    removeErrorMessage("paymentDeadline", this2);
}

export const removeErrorMessage = (name, this2) => {
    if (this2.state.errors.has(name)) {
        let copy = this2.state.errors;
        copy.delete(name);
        this2.setState({ errors: copy });
    }
}

export const handleAmountChange = (event, this2) => {
    if (event.target && event.target.name) {
        const vat = getVat(event.target.value);
        this2.setState({ [event.target.name]: event.target.value, vat: vat })
        if (this2.state.errors) {
            if (this2.state.errors.has(event.target.name)) {
                let copy = this2.state.errors;
                copy.delete(event.target.name);
                this2.setState({ errors: copy });
            }
        } else {
            console.error("no errors");
        }
    } else {
        console.error("no event.target or event.target.name");
    }
}

const getVat = (value) => {
    if (!isNaN(trimSpaces(value))) {
        return Math.round(trimSpaces(value) * 0.2125984);
    } else {
        return value;
    }
}

